import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionStorageService } from '@services/storage.service';
import { catchError, map, Observable, retry, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserService } from './user.service';

export interface IGenericAuditEvent {
	service: string;
	resource: string;
	event: string;
	data: IAuditEventData;

	identityId: string;
	timestamp: number;
}

export interface IAuditEvent {
	service: 'insights';
	resource: 'Report' | 'Impersonate' | 'Login';
	event: 'Created' | 'Read' | 'Updated' | 'Deleted';
	data: IAuditEventData;
}

export interface IAuditEventData {
	[prop: string]: any;
	id: string;
	version: number | undefined;
}

interface IGenericAuditEventResponse {
	result: IGenericAuditEvent;
}

@Injectable({
	providedIn: 'root',
})
export class AuditService {
	constructor(
		private http: HttpClient,
		private userService: UserService,
		private sessionStorageService: SessionStorageService,
	) {
		userService.impersonateUser$.subscribe((c) => {
			if (c) {
				this.LogEvent({
					service: 'insights',
					resource: 'Impersonate',
					event: 'Created',
					data: {
						id: c.id,
						version: undefined,
					},
				}).subscribe((c) => console.log(c));
			}
		});
	}

	public LogEvent(event: IAuditEvent): Observable<IGenericAuditEvent> {
		const account = this.userService.account;
		const headers = {
			Authorization: `Bearer ${this.sessionStorageService.get('User.Authorization')}`,
			'x-account-id': account.id,
		};

		return this.http
			.post<IGenericAuditEventResponse>(`${environment.awsEnvUri}/insights/events`, event, {
				headers,
			})
			.pipe(retry(1), catchError(this.handleError))
			.pipe(map((resp: IGenericAuditEventResponse) => resp.result));
	}

	private handleError(error: { error: { message: string }; status: any; message: any }) {
		let errorMessage = '';
		if (error.error instanceof ErrorEvent) {
			// Get client-side error
			errorMessage = error.error.message;
		} else {
			// Get server-side error
			errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
		}
		if (error.status !== 403) {
			console.log(errorMessage);
			// window.alert(errorMessage);
			return throwError(() => new Error(errorMessage));
		}
		return [];
	}
}
